import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CDP_PUBLIC_URL } from '../../utils/Constants'
import { removeCaptchaBadge } from '../../utils/CDPUtils'
import '../../assets/css/CDPRequestConfirmPage.css'
import { useIntl } from 'react-intl'

const CDPSuccess = () => {
    const navigate = useNavigate()
    const [finishStatus, setFinishStatus] = useState(false)
    const intl = useIntl()

    const onBackButtonEvent = (e) => {
        e.preventDefault()
        if (!finishStatus) {
            if (window.confirm(intl.formatMessage({ id: 'browserBackButtonMsg' }))) {
                setFinishStatus(true)
                navigate(`${CDP_PUBLIC_URL}/recruit`, { state: { } })
            } else {
                window.history.pushState(null, null, window.location.pathname)
                setFinishStatus(false)
            }
        }
    }

    useEffect(() => {
        document.title = 'CDPエントリー｜コンサルタント社員採用｜メットライフ生命'
        window.scrollTo(0, 0)
        removeCaptchaBadge()
        window.history.pushState(null, null, window.location.pathname)
        window.addEventListener('popstate', onBackButtonEvent)
        return () => {
            window.removeEventListener('popstate', onBackButtonEvent)
        }
    }, [])
    return (
        <div id="contents">
        <div className="entrySection cdpComplete">
        <div className="sectionFrame">
        <div className="sectionLeadTxt">ご応募いただきありがとうございます。<br/>エントリーを受け付けました。<br/>内容を確認後、担当者より改めて<br className="smpOnly"/>ご連絡致します。</div>
        <div className="consultantTopBtnBox"><p className="btnStyle consultantTopBtn"><a href="http://www.metlife.co.jp/recruit/consultant/">トップに戻る</a></p></div>
        </div>
        </div>

        <div className="pageup">
        <p><a href="#PAGETOP"></a></p>
        </div>
        </div>
    )
}

export default CDPSuccess
